<template>
  <div>
    <template v-for="relationKey in relations">
      <div
        v-if="relationKey === 'selfRelation'"
        :key="relationKey+'_self'"
        class="gwnl-eval-evaluator__row ellipsis"
      >
        <span class="color-gray-7 lh-50 mr24 yxtbiz-flex-shrink-0 min-width30">{{ $t('pc_gwnl_chart_type_selfLevel') }}</span>
        <span class="color-gray-10 mr24 min-width30" v-if="showWeight">
          {{ row.selfRelation.weight }}%
        </span>
        <yxtbiz-user-name :name="row.fullname" />
      </div>
      <select-evaluator
        v-else
        :key="relationKey"
        :relationKey="relationKey"
        :relation.sync="row[relationKey]"
        :validate="validate"
        :row="row"
        :showWeight="showWeight"
        :dataPermissionCode="dataPermissionCode"
        :functionCode="functionCode"
        :is-save="isSave"
        :id="id"
        :dynamicChoose="dynamicChoose"
        @update-evaluate="updateEvaluateVal($event, relationKey)"
      />
    </template>
  </div>
</template>
<script>
import selectEvaluator from './select-evaluator';
export default {
  components: {
    selectEvaluator
  },
  props: {
    row: Object,
    validate: Boolean,
    showWeight: {
      type: Boolean,
      default: true
    },
    isSave: {
      type: Boolean,
      default: false
    },
    dataPermissionCode: {
      type: String,
      default: 'gwdt_eval_tools_addassessor_extent'
    },
    functionCode: {
      type: String,
      default: 'gwnl_model_position'
    },
    id: {
      type: String,
      default: ''
    },
    dynamicChoose: {
      type: Number,
      default: 0 // 默认胜任力测评
    }
  },
  computed: {
    // 自定义评估关系
    customRelation() {
      return (this.row.customRelation || []).filter(item => Boolean(item.weight)).map(item => ({
        key: item.type,
        orderIndex: item.orderIndex
      }));
    },
    relations() {
      const keys = ['selfRelation', 'leaderRelation', 'equalRelation', 'subordinateRelation'];
      const relationList = keys.flatMap(item => (this.row[item] ? [{ key: item, orderIndex: this.row[item].orderIndex }] : []));
      const sortList = relationList.concat(this.customRelation).sort((a, b) => a.orderIndex - b.orderIndex);
      return sortList.map(list => list.key);
    }
  },

  methods: {
    // 更新评估人的数据
    updateEvaluateVal(obj, relationKey) {
      this.$emit('update-evaluate', { ...obj, key: relationKey });
    }
  }
};
</script>
<style lang="scss" scoped>
.gwnl-eval-evaluator__row {
  border-bottom: 1px solid #e9e9e9;
  margin: 0 -16px;
  padding: 0 16px;
  .lh-50 {
    line-height: 50px;
  }
  .min-width30 {
    min-width: 30px;
  }
  &:last-child {
    border-bottom: none;
  }
}

.w42 {
  display: inline-block;
  width: 42px;
}
</style>
